import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CalendarIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CheckInIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.3383 3.61005H16.8474V2.51005C16.8474 2.12005 16.5273 1.80005 16.1371 1.80005C15.7468 1.80005 15.4267 2.12005 15.4267 2.51005V3.61005H8.58295V2.51005C8.58295 2.12005 8.26277 1.80005 7.87256 1.80005C7.48235 1.80005 7.16218 2.12005 7.16218 2.51005V3.61005H5.67137C4.0805 3.61005 2.7998 4.89005 2.7998 6.47005V19.34C2.7998 20.92 4.0805 22.2 5.66136 22.2H18.3383C19.9191 22.2 21.1998 20.92 21.1998 19.34V6.47005C21.1998 4.89005 19.9191 3.61005 18.3383 3.61005ZM19.769 19.34C19.769 20.1301 19.1287 20.77 18.3383 20.77H5.66136C4.87093 20.77 4.23058 20.1301 4.23058 19.34V9.91005H19.769V19.34ZM19.769 6.47005V8.49005H4.23058V6.47005C4.23058 5.68005 4.87093 5.04005 5.66136 5.04005H7.15217V6.14005C7.15217 6.53005 7.47234 6.85005 7.86256 6.85005C8.25277 6.85005 8.57294 6.53005 8.57294 6.14005V5.04005H15.4067V6.14005C15.4067 6.53005 15.7268 6.85005 16.117 6.85005C16.5073 6.85005 16.8274 6.53005 16.8274 6.14005V5.04005H18.3182C19.1087 5.04005 19.749 5.68005 19.749 6.47005H19.769Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CalendarIcon;
